import React, { useEffect, useImperativeHandle, useState } from "react";
import GroupTitle from "./GroupTitle";
import { CircleLoader } from "../Elements";
import { getCustomerBalance } from "../../../common/helpers/paymentHelpers";
import { formatCurrency, formatDateOnFrontWithoutTime } from "../../../lib/helpers";
import { getCurrencySymbolByCurrencyId } from "../../../common/helpers/getCurrencySymbolByCurrencyId";
import { RootStateType } from "../../../store/RootState";
import { useSelector } from "react-redux";


type Props = {
    isCustomerBalance: boolean,
    amount?: string,
    customerId: number,
    description?: string,
    isPaymentLink: boolean,
    invoiceNumber?: string,
    gibInvoiceNumber?: string,
    invoicePaymentDate?: any,
    invoiceDate?:any,
    currencyId: number
}
export type AmountInfoRefProp = {
    selectBalance: () => void
}

const AmountInformationArea = React.forwardRef<AmountInfoRefProp, Props>((props: Props, ref) => {
    const { customerId, isCustomerBalance, amount, description, isPaymentLink, gibInvoiceNumber,
         invoiceNumber, invoicePaymentDate, invoiceDate, currencyId } = props;
    const [customerBalance, setCustomerBalance] = useState("");
    const [customerBalanceError, setCustomerBalanceError] = useState("");
    const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);

    useImperativeHandle(ref, () => ({

        
        selectBalance() {
            if (customerId > 0 && props.isCustomerBalance) {
                selectCustomerBalance();
            }
        }
    }));

    const [customerBalanceLoading, setCustomerBalanceLoading] = useState(false);


    const selectCustomerBalance = async () => {
        setCustomerBalanceLoading(true);
        setCustomerBalanceError("");

        const balance = await getCustomerBalance(customerId);
        if (balance.isSuccess) {
            setCustomerBalance(formatCurrency(balance.data));
        } else {
            setCustomerBalanceError(balance.data);
        }

        setCustomerBalanceLoading(false);

    }

    if (isCustomerBalance && !(customerId > 0)) {
        return null;
    }
    let title = isCustomerBalance ? "Borç Bakiyesi" : "Ödeme Tutarı";
    if (isPaymentLink && invoiceNumber) {
        title = "Fatura Bilgileri"
    }

    return (
        <div className="w-full px-6 py-4 bg-white shadow-custom rounded-lg  mt-6">
            <GroupTitle title={title} lineclass="!border-primary" />
            {customerBalanceLoading ? (
                <div className="text-right text-black text-2xl font-bold  mt-4">
                    <CircleLoader loadingMessage="Borç bakiyesi yükleniyor..." />

                </div>
            ) : (isCustomerBalance && customerBalanceError?.length > 0) ? (
                <div className="text-danger  text-sm text-center">
                    {customerBalanceError}
                </div>
            ) : (
                <div className="text-right text-black text-2xl font-bold  mt-4">{getCurrencySymbolByCurrencyId(currencyList, props.currencyId)} {(isCustomerBalance && customerBalance ? customerBalance : formatCurrency(amount)) || "0.00"}</div>
            )}
                {invoiceDate && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Tarihi:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {formatDateOnFrontWithoutTime(invoiceDate)}
                    </div>
                </div>
            )}
            {invoicePaymentDate && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Vade Tarihi:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {formatDateOnFrontWithoutTime(invoicePaymentDate)}
                    </div>
                </div>
            )}
            {invoiceNumber && (

                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Numarası:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {invoiceNumber}
                    </div>
                </div>
            )}
            {gibInvoiceNumber && (
                <div className="flex justify-between my-2">
                    <div className="text-zinc-400 text-xs font-bold" >
                        Fatura Numarası:
                    </div>
                    <div className="text-zinc-800 text-xs font-normal" >
                        {gibInvoiceNumber}
                    </div>
                </div>
            )}

            {description && (
                <div className="text-center text-zinc-500 text-sm font-normal mt-3 break-words">
                    {description}
                </div>
            )}
        </div>
    );
})
export default AmountInformationArea;